import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCircle } from '@fortawesome/free-solid-svg-icons';

const SegmentBadge = ({ segmentValue, hasAccess }) => {
  if (!segmentValue) {
    return null;
  }

  return hasAccess ? (
    <FontAwesomeIcon icon={faCheck} className="text-success" />
  ) : (
    <FontAwesomeIcon icon={faCircle} size="xs" style={{ color: '#6c757d' }} />
  );
};

export default SegmentBadge;
